import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router-dom";

import { IAsyncData } from "../../../../core/models";
import { Routing } from "../../../../core/routing";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { budgetEditFormValidation, IBudget, IBudgetForm } from "../../data/entities";
import { BudgetForm } from "../components/form";
import { budgetRedux } from "../state/state";

export const BudgetEditPage: React.FC = () => {
  const match = useRouteMatch<{ id: string }>();
  const id = match.params.id;
  const dispatch = useDispatch();
  const history = useHistory();

  const budgetDetailBranch = useSelector<IAppReduxState, IAsyncData<IBudget>>((state) => state.budget.details);
  const editBudgetBranch = useSelector<IAppReduxState, IAsyncData<void>>((state) => state.budget.edit);

  useEffect(() => {
    dispatch(budgetRedux.actions.getDetail(id));
  }, [dispatch, id]);

  const onSubmit = async (form: IBudgetForm): Promise<void> => {
    await dispatch(budgetRedux.actions.edit(id, form));
    history.push(Routing.generateDetailRoute(ROUTES.budget, id));
  };

  return (
    <BudgetForm
      initialData={budgetDetailBranch}
      onSubmit={onSubmit}
      branch={editBudgetBranch}
      validationSchema={budgetEditFormValidation}
      submitTitle="Edit"
    />
  );
};
